import React from 'react';

import VoiceoverRecordingPresentation from 'js/src/components/app/recorder/VoiceoverRecordingPresentation';
import Callout from 'js/src/components/common/ui/Callout';

const VOICE_CLONING_PROMPTER_SCRIPT = `\n\n\nHi there. Thanks for taking a moment to listen.
Today, I want to share a simple idea: stories shape the way we see the world. Whether it's a quick update, a thoughtful explanation, or a big announcement, the way something is said matters just as much as what is said.
Sometimes I speak with energy and excitement. Other times, I slow down and emphasize a key point. That contrast makes communication feel human, clear, and engaging.
This recording is a short sample of my voice — natural, conversational, and expressive — so it can be used to create high-quality narration that sounds just like me.`;

type VoiceCloningRecordStepProps = {
    onRecordingComplete: (blob: Blob) => void;
};

const VoiceCloningRecordStep: React.FC<VoiceCloningRecordStepProps> = ({ onRecordingComplete }) => (
    <>
        <Callout
            text={
                <>
                    For best result, record at least 20 seconds of clear audio without any reverb,
                    artifacts, or background noise of any kind, by reading the script below.{' '}
                    <a
                        href="https://help.lumen5.com/en/article/best-practices-to-clone-your-voice-7mdmou/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Click here
                    </a>{' '}
                    to learn more best practices to clone your voice.
                </>
            }
        />
        <VoiceoverRecordingPresentation
            onRecordingComplete={onRecordingComplete}
            initialPrompterVisible
            prompterDefaultText={VOICE_CLONING_PROMPTER_SCRIPT}
        />
    </>
);

export default VoiceCloningRecordStep;
